import React, { useEffect, useState } from 'react';
import './index.scss';
import logoImage from '../../assets/jeunessee.png';

const Preloader = () => {
  const [progressVal, setProgressVal] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setProgressVal(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 200);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="jeuness-preloader">
      <div className="jeuness-preloader__container">
        <img src={logoImage} alt="Jeun'ESS" className="jeuness-preloader__logo" />
        
        <div className="jeuness-preloader__brand">
          <h1 className="jeuness-preloader__title">JEUN'ESS MARKET</h1>
          <p className="jeuness-preloader__subtitle">Marketplace B2B Tunisienne</p>
        </div>
        
        <div className="jeuness-preloader__progress">
          <div className="jeuness-preloader__progress-bar">
            <div 
              className="jeuness-preloader__progress-fill" 
              style={{ width: `${Math.min(progressVal, 100)}%` }}
            />
          </div>
          <span className="jeuness-preloader__percentage">
            {Math.floor(Math.min(progressVal, 100))}%
          </span>
        </div>
        
        <p className="jeuness-preloader__message">
          Chargement de votre marketplace...
        </p>
      </div>
    </div>
  );
};

export default Preloader;